import { PinnedFieldsVisibility } from "@mapmycustomers/shared";
import Visibility from "@mapmycustomers/shared/enum/Visibility";

import { InternalFieldDescription } from "../EntityColumnsConfiguration";

// How strictly a pin is locked: org over team over private. The display only keeps each merged
// row's field, so the rank can't be seen there today; it stays so the merge is mobile's, row for row.
const LOCK_RANK: Record<PinnedFieldsVisibility, number> = {
  [Visibility.PRIVATE]: 2,
  [Visibility.SHARED_WITH_ORGANIZATION]: 0,
  [Visibility.SHARED_WITH_TEAM]: 1,
};

// The shared rows first, then the subtype's rows that are not already shared. A row in both keeps
// its shared position and takes the subtype row's lock when that is stricter.
const appendSubtypeColumns = (
  shared: InternalFieldDescription[],
  subtype: InternalFieldDescription[]
): InternalFieldDescription[] => {
  const subtypeByName = new Map(subtype.map((row) => [row.field.name, row]));
  const sharedNames = new Set(shared.map(({ field }) => field.name));

  return [
    ...shared.map((row) => {
      const duplicate = subtypeByName.get(row.field.name);
      return duplicate && LOCK_RANK[duplicate.visibility] < LOCK_RANK[row.visibility]
        ? { ...duplicate, displayOrder: row.displayOrder }
        : row;
    }),
    ...subtype.filter(({ field }) => !sharedNames.has(field.name)),
  ];
};

export default appendSubtypeColumns;
